<template>
  <Stack v-if="state === 'search'" space="small">
    <AddressSearch
      :isListButtonShown="state === 'search'"
      :errors="addressErrors"
      clearOnSelection
      :label="label"
      @onChange="handleAddressSelectionAndDisplayForm"
      @onListButtonClick="handleListButtonClick"
    />
    <div v-if="state === 'search'" class="flex flex-col items-start justify-between gap-1">
      <TextButton text="Enter Manually" @click="state = 'form'" />
      <TextButton
        v-if="alternativeLabel"
        color="subtle"
        @click="emit('onAlternativeClick')"
        :text="alternativeLabel"
      ></TextButton>
    </div>
  </Stack>
  <Stack v-if="state === 'form'" space="small">
    <AddressForm
      :address="address"
      :errors="addressErrors"
      :hasMap="hasMap"
      :hasCountryInput="hasCountryInput"
      :isDisabled="isDisabled"
      @close="state = 'search'"
      @onChange="handleAddressUpdate"
      @onAddressSelection="handleAddressSelection"
    />
    <div v-if="state === 'form'" class="flex items-center justify-end">
      <TextButton text="Back to Search" @click="state = 'search'" />
    </div>
  </Stack>
</template>

<script setup>
import { ref, toRefs } from 'vue'
import { Stack, TextButton } from '@aryeo/runway'

import AddressSearchApi from '@/Services/Api/Company/V1/AddressSearchApi'

import AddressForm from './AddressForm.vue'
import AddressSearch from './AddressSearch.vue'

const props = defineProps({
  address: {
    type: Object,
    default: () => ({}),
  },
  addressErrors: {
    type: Object,
    default: null,
  },
  alternativeLabel: {
    type: String,
    default: undefined,
  },
  hasMap: {
    type: Boolean,
    default: true,
  },
  hasCountryInput: {
    type: Boolean,
    default: false,
  },
  isListingContentComplete: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: 'Search Address',
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits([
  'onAddressChange',
  'onAddressRemove',
  'onAddressSelection',
  'onAlternativeClick',
])

const { addressErrors } = toRefs(props)

// State
const state = ref(props.address?.latitude || props.address?.longitude ? 'form' : 'search')

// Search
async function handleAddressSelection({ external_id }) {
  handleAddressUpdate({
    key: 'is_map_dirty',
    value: false,
  })

  await AddressSearchApi.show(external_id).then(({ data: { data } }) => {
    emit('onAddressSelection', {
      ...data,
      id: null,
      is_map_dirty: false,
    })
  })
}

async function handleAddressSelectionAndDisplayForm({ external_id }) {
  await handleAddressSelection({ external_id })
  state.value = 'form'
}

const handleListButtonClick = () => {
  state.value = 'form'
}

// Form
const handleAddressUpdate = (event) => {
  emit('onAddressChange', event)
}
</script>
